
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities/holiday2022/rewards",
      function () {
        return require("private-next-pages/activities/holiday2022/rewards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities/holiday2022/rewards"])
      });
    }
  